import React from "react"

const CheckIcon: React.FC = () => (
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.70457 7.27842L1.21934 4.79319C0.940018 4.51387 0.488809 4.51387 0.20949 4.79319C-0.0698299 5.07251 -0.0698299 5.52372 0.20949 5.80304L3.20322 8.79677C3.48254 9.07609 3.93375 9.07609 4.21307 8.79677L11.7905 1.21934C12.0698 0.940017 12.0698 0.488809 11.7905 0.20949C11.5112 -0.0698299 11.06 -0.0698299 10.7807 0.20949L3.70457 7.27842Z"
      fill="#067BF2"
    />
  </svg>
)

export default CheckIcon
